import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceSpaceWithDash'
})
export class ReplaceSpaceWithDashPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value.replace(/\s+/g, '-');
  }

}
